// @flow

export const gtHaptik = "'GT Haptik', sans-serif"
export const gtHaptikMedium = "'GT Haptik Medium', sans-serif"
export const gtHaptikMediumRotalic = "'GT Haptik Medium Rotalic', sans-serif"
export const gtHaptikBold = "'GT Haptik Bold', sans-serif"
export const inter = "'Inter', sans-serif"
